$('.container-row-areas-work__slider').slick({
  infinite: true,
  slidesToShow:  document.documentElement.clientWidth <= 425 ? 2 : 8,
  slidesToScroll: document.documentElement.clientWidth <= 425 ? 1 : 4,
  autoplay: true,
  autoplaySpeed: 2000,
  prevArrow: document.documentElement.clientWidth <= 425 ? "" : "<div class='slider__arrow'></div>",
  nextArrow: document.documentElement.clientWidth <= 425 ? "" : "<div class='slider__arrow slider__arrow_next'></div>",
});

// scroll

document.addEventListener('scroll', function(){
  if(window.pageYOffset > 1){
    $('.container_scroll-nav').addClass('show');
  } else {
    $('.container_scroll-nav').removeClass('show');
  }
});

// popup

var popup = document.querySelector('.main__make-request_popup');

document.addEventListener('click', function(e){
  if(e.target.classList.contains('make-request__close') || e.target === popup){
    popup.classList.remove('show');
  }
  addClassClick(e);
});

document.addEventListener('touchend', function(e){
  addClassClick(e);
});

function addClassClick(e){
  if(e.target.classList.contains('header__burger')){
    upstairs.classList.remove('show');
    document.querySelector('.nav_header').classList.add('show');
  }
  if(e.target.classList.contains('nav_header__cross')){
    document.querySelector('.nav_header').classList.remove('show');
  }
  if(e.target === upstairs){
    ascentUpstairs(0);
  }
  if(e.target.classList.contains('button_make-upstairs-request')){
    if(document.documentElement.clientWidth <= 425){
      ascentUpstairs(document.querySelector('.container_make-request_mob').offsetTop  - document.querySelector('.header').getBoundingClientRect().height);
    } else {
      popup.classList.add('show');
    }  
  }
}

document.addEventListener('keydown', function(e){
  if(e.keyCode === 27){
    popup.classList.remove('show');
  }
});


// upstairs

var upstairs = document.querySelector('.upstairs');

if(document.documentElement.clientWidth <= 425 && window.pageYOffset > document.querySelector('.header').getBoundingClientRect().height){
  upstairs.classList.add('show');
}

document.addEventListener('touchmove', function(e){
  if(document.documentElement.clientWidth <= 425 && !document.querySelector('.nav_header').classList.contains('show')){
    upstairs.classList.add('show');
  }
  if(window.pageYOffset < document.querySelector('.header').getBoundingClientRect().height){
    upstairs.classList.remove('show');
  }
});  

var idRequestAnimationFrame;
var speedAscent = 35;

function ascentUpstairs(x){
  idRequestAnimationFrame = requestAnimationFrame(function ascent(){
    
    if(window.pageYOffset > x){
      window.scrollTo(0,window. pageYOffset - speedAscent);
    } 
    if(window.pageYOffset < x){
      window.scrollTo(0,window. pageYOffset + speedAscent);
    } 
    if(Math.abs(x - window.pageYOffset) <= speedAscent*2){
      window.scrollTo(0,x);
    }
    if(Math.abs(window.pageYOffset - x) <= speedAscent){
      cancelAnimationFrame(idRequestAnimationFrame);
      if(window.pageYOffset === 0){
        upstairs.classList.remove('show');
      }
      return;
    }
    idRequestAnimationFrame = requestAnimationFrame(ascent);
  })
}

// search result 

var list = document.querySelectorAll('.list-setting__tuning-container');
list = Array.from(list);
var tuning = document.querySelectorAll('.list-setting__tuning');
tuning = Array.from(tuning);

tuning.forEach(function(item, index){
  item.addEventListener('click', function(e){
    this.classList.toggle('list-setting__tuning_open');
    list[index].querySelector('.tuning__container').classList.toggle('show');
  });
});

// detailed item photo

document.addEventListener('click', function(e){
  if(e.target.classList.contains('item-container__item-photo_min') && !e.target.classList.contains('item-container__item-photo_active')){
    var mainItemPhoto = document.querySelector('.item-container__item-photo_main');
    var activeItemPhoto = document.querySelector('.item-container__item-photo_active');
    activeItemPhoto.classList.remove('item-container__item-photo_active');
    e.target.classList.add('item-container__item-photo_active');
    mainItemPhoto.setAttribute('src', e.target.getAttribute('src'));
  }
});

// viewport

var headerMob = document.querySelector('.container__header_mob');

if(document.documentElement.clientWidth <= 1175 && document.documentElement.clientWidth > 425 ){
  headerMob.style.width = document.documentElement.clientWidth + 'px';
}